import StarRoundedIcon from "@mui/icons-material/StarRounded";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

export function UpgradeVipDialog({
  open,
  onClose,
  onConfirm,
  vipPlan,
  kitPlan,
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  vipPlan: any;
  kitPlan: any;
}) {
  const finalPrice = vipPlan.priceUsd - kitPlan.priceUsd;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 4,
          p: 0,
          background: "#ffffff",
          boxShadow: "0 8px 30px rgba(0,0,0,0.12)",
          border: "1px solid #e5e7eb",
          width: "100%",
          maxWidth: 480,
        },
      }}
    >
      <Box
        sx={{
          width: "100%",
          py: 1.2,
          px: 2,
          bgcolor: "#d1b560",
          background:
            "linear-gradient(90deg, #C9A34E 0%, #E5C979 50%, #C9A34E 100%)",
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          fontWeight: 600,
          fontSize: "0.95rem",
        }}
      >
        Mejora tu plan y obtén beneficios VIP
      </Box>

      <DialogTitle
        sx={{
          fontWeight: 800,
          textAlign: "center",
          mt: 1,
          fontSize: "1.4rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 1,
        }}
      >
        <StarRoundedIcon sx={{ fontSize: 28, color: "#C9A34E" }} />
        Actualiza al Plan VIP
      </DialogTitle>

      <DialogContent sx={{ textAlign: "center", px: 4 }}>
        <Typography sx={{ mb: 2, lineHeight: 1.5, color: "#444" }}>
          Como ya adquiriste el <strong>Kit</strong>, obtendrás un descuento
          automático equivalente al monto que pagaste por el kit.
        </Typography>

        <Box
          sx={{
            p: 2.5,
            borderRadius: 3,
            backgroundColor: "#F9FAFB",
            border: "1px solid #E5E7EB",
            mb: 2,
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
            textAlign: "left",
          }}
        >
          <Typography sx={{ mb: 0.5 }}>
            <strong>Precio VIP:</strong> ${vipPlan.priceUsd} USD
          </Typography>
          <Typography sx={{ mb: 0.5 }}>
            <strong>Descuento por tu Kit:</strong> -${kitPlan.priceUsd} USD
          </Typography>

          <Box
            sx={{
              mt: 1.5,
              pt: 1.2,
              borderTop: "1px solid #ddd",
              display: "flex",
              justifyContent: "space-between",
              fontSize: "1.1rem",
            }}
          >
            <strong>Total a pagar:</strong>
            <strong>${finalPrice} USD</strong>
          </Box>
        </Box>

        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ pb: 1, mt: 1 }}
        >
          ¿Deseas continuar con la actualización?
        </Typography>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            borderRadius: "999px",
            px: 4,
            textTransform: "none",
            borderColor: "#cbd5e1",
            color: "#475569",
          }}
        >
          Cancelar
        </Button>

        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{
            borderRadius: "999px",
            px: 4,
            textTransform: "none",
            background: "linear-gradient(90deg, #0E1EFD, #0099FF)",
            boxShadow: "0 0 15px rgba(0, 100, 255, 0.3)",
          }}
        >
          Continuar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
